module.exports = __webpack_public_path__ + "img/guanbi@3x.eb906d4e.svg";